import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'rrpCalculatorVisible';
const EVENT_NAME = 'rrp-calculator-visibility-change';

function readStoredValue() {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

function writeStoredValue(value) {
    try {
        sessionStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch (e) {
        // sessionStorage unavailable (e.g. private mode) - visibility just won't persist
    }
}

// RRP calculator is opt-in per session: hidden by default, toggled on in Profile,
// and shared across the product list/item/details components without a page reload.
export function useRrpCalculatorVisibility() {
    const [visible, setVisible] = useState(readStoredValue);

    useEffect(() => {
        function handleChange(e) {
            setVisible(e.detail);
        }
        window.addEventListener(EVENT_NAME, handleChange);
        return () => window.removeEventListener(EVENT_NAME, handleChange);
    }, []);

    const toggleVisibility = useCallback(() => {
        setVisible(prev => {
            const next = !prev;
            writeStoredValue(next);
            window.dispatchEvent(new CustomEvent(EVENT_NAME, {detail: next}));
            return next;
        });
    }, []);

    return [visible, toggleVisibility];
}
